/**
 * SDM REWARDS - Multi-language Translations
 * Supported languages: English (en), French (fr)
 */

export const translations = {
  en: {
    // ============== NAVIGATION ==============
    nav_home: "Home",
    nav_about: "About",
    nav_how_it_works: "How It Works",
    nav_cards: "Membership Cards",
    nav_partners: "Partners",
    nav_contact: "Contact",
    nav_login: "Login",
    nav_get_started: "Get Started",
    nav_client_login: "Client Login",
    nav_merchant_login: "Merchant Login",
    
    // ============== HERO SECTION ==============
    hero_tagline: "CASHBACK REWARDS PLATFORM",
    hero_title: "Earn Cashback on Every Purchase",
    hero_subtitle: "Join SDM Rewards and receive instant cashback when you shop at partner merchants. The more you spend, the more you earn.",
    hero_cta_client: "Join as Customer",
    hero_cta_merchant: "Become a Partner",
    hero_stats_members: "Active Members",
    hero_stats_merchants: "Partner Merchants",
    hero_stats_cashback: "Cashback Distributed",
    
    // ============== VALUE PROPOSITION ==============
    value_title: "Why Choose SDM Rewards?",
    value_subtitle: "Join Africa's smartest community of consumers and merchants",
    value_instant: "Instant Cashback",
    value_instant_desc: "Receive cashback directly to your wallet after every purchase",
    value_partners: "Growing Network",
    value_partners_desc: "Access hundreds of partner merchants across Ghana",
    value_referral: "Earn from Referrals",
    value_referral_desc: "Invite friends and earn GHS 3 for each successful referral",
    value_secure: "Secure & Trusted",
    value_secure_desc: "Bank-grade security for all your transactions",
    value_easy: "Easy to Use",
    value_easy_desc: "Simple QR code scanning for instant payments",
    value_support: "24/7 Support",
    value_support_desc: "Our team is always here to help you",
    
    // ============== MEMBERSHIP CARDS ==============
    cards_title: "Choose Your Membership Card",
    cards_subtitle: "Start earning cashback today with the card that fits your lifestyle",
    
    card_silver_name: "Silver Card",
    card_silver_price: "GHS 25",
    card_silver_benefit1: "Access to SDM cashback network",
    card_silver_benefit2: "Up to 10% cashback at partner merchants",
    card_silver_benefit3: "Referral rewards program",
    card_silver_benefit4: "Merchant promotions access",
    card_silver_benefit5: "Welcome bonus: GHS 1",
    
    card_gold_name: "Gold Card",
    card_gold_price: "GHS 50",
    card_gold_benefit1: "Higher cashback opportunities",
    card_gold_benefit2: "Priority access to promotions",
    card_gold_benefit3: "Special birthday bonus",
    card_gold_benefit4: "Premium merchant access",
    card_gold_benefit5: "Enhanced referral visibility",
    card_gold_benefit6: "Welcome bonus: GHS 1",
    
    card_platinum_name: "Platinum Card",
    card_platinum_price: "GHS 100",
    card_platinum_benefit1: "Maximum cashback at all partners",
    card_platinum_benefit2: "VIP promotions & exclusive offers",
    card_platinum_benefit3: "Priority support",
    card_platinum_benefit4: "Exclusive merchant offers",
    card_platinum_benefit5: "Higher promotional bonuses",
    card_platinum_benefit6: "Special campaign invitations",
    card_platinum_benefit7: "Welcome bonus: GHS 1",
    
    card_cta: "Get This Card",
    card_popular: "Most Popular",
    card_premium: "Premium",
    
    // ============== HOW IT WORKS ==============
    how_title: "How It Works",
    how_subtitle: "Start earning cashback in 3 simple steps",
    how_step1_title: "Get Your Card",
    how_step1_desc: "Choose and purchase your SDM membership card",
    how_step2_title: "Shop at Partners",
    how_step2_desc: "Pay using your SDM QR code at partner merchants",
    how_step3_title: "Earn Cashback",
    how_step3_desc: "Receive instant cashback directly to your wallet",
    
    // ============== FOR MERCHANTS ==============
    merchants_title: "Grow Your Business with SDM",
    merchants_subtitle: "Join our network of successful partner merchants",
    merchants_benefit1: "Attract New Customers",
    merchants_benefit1_desc: "Get discovered by thousands of SDM members looking to shop",
    merchants_benefit2: "Increase Sales",
    merchants_benefit2_desc: "Customers spend more when they earn cashback rewards",
    merchants_benefit3: "Customer Loyalty",
    merchants_benefit3_desc: "Build lasting relationships with repeat customers",
    merchants_benefit4: "Platform Visibility",
    merchants_benefit4_desc: "Feature your business in our partner directory",
    merchants_benefit5: "Smart Marketing",
    merchants_benefit5_desc: "Access marketing tools to promote your business",
    merchants_benefit6: "Easy Setup",
    merchants_benefit6_desc: "Get started in minutes with simple QR code payments",
    merchants_cta: "Become a Partner",
    merchants_testimonial: "Joining SDM Rewards helped our business attract new customers and increase repeat visits.",
    merchants_testimonial_author: "Kofi M., Restaurant Owner",
    
    // ============== FOR CUSTOMERS ==============
    customers_title: "Benefits for Customers",
    customers_subtitle: "Make every purchase count",
    customers_benefit1: "Earn on Daily Purchases",
    customers_benefit1_desc: "Get cashback on your everyday shopping",
    customers_benefit2: "Discover New Places",
    customers_benefit2_desc: "Find new partner merchants in your area",
    customers_benefit3: "Instant Rewards",
    customers_benefit3_desc: "Use your cashback immediately",
    customers_benefit4: "Refer & Earn",
    customers_benefit4_desc: "Share your code and earn bonus rewards",
    customers_cta: "Start Earning Today",
    
    // ============== TRUST SECTION ==============
    trust_title: "Trusted & Secure",
    trust_subtitle: "Your security is our priority",
    trust_secure_payments: "Secure Payments",
    trust_data_protection: "Data Protection",
    trust_verified_merchants: "Verified Merchants",
    trust_powered_by: "Powered by",
    
    // ============== SHARE SECTION ==============
    share_tagline: "SPREAD THE WORD",
    share_title: "Share SDM Rewards with Friends",
    share_subtitle: "Help your friends discover cashback rewards. Share on your favorite platform!",
    
    // ============== CTA SECTION ==============
    cta_title: "Ready to Start Earning?",
    cta_subtitle: "Join thousands of smart shoppers earning cashback on every purchase",
    cta_button: "Get Started Now",
    
    // ============== FOOTER ==============
    footer_description: "Ghana's premier cashback rewards platform connecting smart consumers with partner merchants.",
    footer_quick_links: "Quick Links",
    footer_support: "Support",
    footer_legal: "Legal",
    footer_contact: "Contact Us",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",
    footer_merchant_terms: "Merchant Terms",
    footer_referral_terms: "Referral Program Terms",
    footer_cashback_rules: "Cashback Rules",
    footer_abuse_policy: "Abuse Policy",
    footer_faq: "FAQ",
    footer_contact: "Contact Support",
    footer_copyright: "© 2026 SDM Rewards. All rights reserved.",
    footer_address: "Accra, Ghana",
    
    // ============== COMMON ==============
    learn_more: "Learn More",
    sign_up: "Sign Up",
    login: "Login",
    email: "Email",
    phone: "Phone Number",
    password: "Password",
    confirm_password: "Confirm Password",
    full_name: "Full Name",
    business_name: "Business Name",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // ============== DASHBOARD COMMON ==============
    dashboard: "Dashboard",
    transactions: "Transactions",
    settings: "Settings",
    logout: "Logout",
    balance: "Balance",
    cashback_balance: "Cashback Balance",
    total_earned: "Total Earned",
    recent_activity: "Recent Activity",
    view_all: "View All",
    no_transactions: "No transactions yet",
    
    // ============== SEO ==============
    seo_title: "SDM Rewards - Cashback Platform Ghana | Earn Rewards on Every Purchase",
    seo_description: "Join SDM Rewards, Ghana's premier cashback platform. Earn instant cashback at partner merchants. Get your membership card today and start saving!",
    seo_keywords: "cashback Ghana, loyalty rewards Africa, cashback shopping, rewards program Ghana, SDM Rewards"
  },
  
  fr: {
    // ============== NAVIGATION ==============
    nav_home: "Accueil",
    nav_about: "À propos",
    nav_how_it_works: "Comment ça marche",
    nav_cards: "Cartes de membre",
    nav_partners: "Partenaires",
    nav_contact: "Contact",
    nav_login: "Connexion",
    nav_get_started: "Commencer",
    nav_client_login: "Espace Client",
    nav_merchant_login: "Espace Marchand",
    
    // ============== HERO SECTION ==============
    hero_tagline: "PLATEFORME DE CASHBACK",
    hero_title: "Gagnez du Cashback sur Chaque Achat",
    hero_subtitle: "Rejoignez SDM Rewards et recevez du cashback instantané lorsque vous achetez chez les commerçants partenaires. Plus vous dépensez, plus vous gagnez.",
    hero_cta_client: "Rejoindre en tant que Client",
    hero_cta_merchant: "Devenir Partenaire",
    hero_stats_members: "Membres Actifs",
    hero_stats_merchants: "Marchands Partenaires",
    hero_stats_cashback: "Cashback Distribué",
    
    // ============== VALUE PROPOSITION ==============
    value_title: "Pourquoi Choisir SDM Rewards ?",
    value_subtitle: "Rejoignez la communauté la plus intelligente de consommateurs et marchands d'Afrique",
    value_instant: "Cashback Instantané",
    value_instant_desc: "Recevez du cashback directement sur votre portefeuille après chaque achat",
    value_partners: "Réseau en Croissance",
    value_partners_desc: "Accédez à des centaines de marchands partenaires au Ghana",
    value_referral: "Gagnez en Parrainant",
    value_referral_desc: "Invitez des amis et gagnez 3 GHS pour chaque parrainage réussi",
    value_secure: "Sécurisé et Fiable",
    value_secure_desc: "Sécurité bancaire pour toutes vos transactions",
    value_easy: "Facile à Utiliser",
    value_easy_desc: "Simple scan QR code pour des paiements instantanés",
    value_support: "Support 24/7",
    value_support_desc: "Notre équipe est toujours là pour vous aider",
    
    // ============== MEMBERSHIP CARDS ==============
    cards_title: "Choisissez Votre Carte de Membre",
    cards_subtitle: "Commencez à gagner du cashback dès aujourd'hui avec la carte qui vous correspond",
    
    card_silver_name: "Carte Silver",
    card_silver_price: "25 GHS",
    card_silver_benefit1: "Accès au réseau cashback SDM",
    card_silver_benefit2: "Jusqu'à 10% de cashback chez les partenaires",
    card_silver_benefit3: "Programme de récompenses de parrainage",
    card_silver_benefit4: "Accès aux promotions des marchands",
    card_silver_benefit5: "Bonus de bienvenue : 1 GHS",
    
    card_gold_name: "Carte Gold",
    card_gold_price: "50 GHS",
    card_gold_benefit1: "Opportunités de cashback plus élevées",
    card_gold_benefit2: "Accès prioritaire aux promotions",
    card_gold_benefit3: "Bonus spécial anniversaire",
    card_gold_benefit4: "Accès aux marchands premium",
    card_gold_benefit5: "Visibilité renforcée dans le système de parrainage",
    card_gold_benefit6: "Bonus de bienvenue : 1 GHS",
    
    card_platinum_name: "Carte Platinum",
    card_platinum_price: "100 GHS",
    card_platinum_benefit1: "Cashback maximum chez tous les partenaires",
    card_platinum_benefit2: "Promotions VIP et offres exclusives",
    card_platinum_benefit3: "Support prioritaire",
    card_platinum_benefit4: "Offres exclusives des marchands",
    card_platinum_benefit5: "Bonus promotionnels plus élevés",
    card_platinum_benefit6: "Invitations aux campagnes spéciales",
    card_platinum_benefit7: "Bonus de bienvenue : 1 GHS",
    
    card_cta: "Obtenir cette Carte",
    card_popular: "Plus Populaire",
    card_premium: "Premium",
    
    // ============== HOW IT WORKS ==============
    how_title: "Comment ça Marche",
    how_subtitle: "Commencez à gagner du cashback en 3 étapes simples",
    how_step1_title: "Obtenez Votre Carte",
    how_step1_desc: "Choisissez et achetez votre carte de membre SDM",
    how_step2_title: "Achetez chez les Partenaires",
    how_step2_desc: "Payez avec votre QR code SDM chez les marchands partenaires",
    how_step3_title: "Gagnez du Cashback",
    how_step3_desc: "Recevez du cashback instantané directement sur votre portefeuille",
    
    // ============== FOR MERCHANTS ==============
    merchants_title: "Développez Votre Entreprise avec SDM",
    merchants_subtitle: "Rejoignez notre réseau de marchands partenaires prospères",
    merchants_benefit1: "Attirez de Nouveaux Clients",
    merchants_benefit1_desc: "Soyez découvert par des milliers de membres SDM",
    merchants_benefit2: "Augmentez Vos Ventes",
    merchants_benefit2_desc: "Les clients dépensent plus lorsqu'ils gagnent des récompenses",
    merchants_benefit3: "Fidélisation Client",
    merchants_benefit3_desc: "Construisez des relations durables avec des clients réguliers",
    merchants_benefit4: "Visibilité Plateforme",
    merchants_benefit4_desc: "Mettez en avant votre entreprise dans notre répertoire",
    merchants_benefit5: "Marketing Intelligent",
    merchants_benefit5_desc: "Accédez à des outils marketing pour promouvoir votre entreprise",
    merchants_benefit6: "Installation Facile",
    merchants_benefit6_desc: "Démarrez en quelques minutes avec les paiements QR code",
    merchants_cta: "Devenir Partenaire",
    merchants_testimonial: "Rejoindre SDM Rewards a permis à notre commerce d'attirer de nouveaux clients et d'augmenter les visites répétées.",
    merchants_testimonial_author: "Kofi M., Propriétaire de Restaurant",
    
    // ============== FOR CUSTOMERS ==============
    customers_title: "Avantages pour les Clients",
    customers_subtitle: "Faites compter chaque achat",
    customers_benefit1: "Gagnez sur vos Achats Quotidiens",
    customers_benefit1_desc: "Obtenez du cashback sur vos achats de tous les jours",
    customers_benefit2: "Découvrez de Nouveaux Endroits",
    customers_benefit2_desc: "Trouvez de nouveaux marchands partenaires près de chez vous",
    customers_benefit3: "Récompenses Instantanées",
    customers_benefit3_desc: "Utilisez votre cashback immédiatement",
    customers_benefit4: "Parrainez et Gagnez",
    customers_benefit4_desc: "Partagez votre code et gagnez des bonus",
    customers_cta: "Commencez à Gagner Aujourd'hui",
    
    // ============== TRUST SECTION ==============
    trust_title: "Fiable et Sécurisé",
    trust_subtitle: "Votre sécurité est notre priorité",
    trust_secure_payments: "Paiements Sécurisés",
    trust_data_protection: "Protection des Données",
    trust_verified_merchants: "Marchands Vérifiés",
    trust_powered_by: "Propulsé par",
    
    // ============== SHARE SECTION ==============
    share_tagline: "PARTAGEZ",
    share_title: "Partagez SDM Rewards avec vos Amis",
    share_subtitle: "Aidez vos amis à découvrir les récompenses cashback. Partagez sur votre plateforme préférée !",
    
    // ============== CTA SECTION ==============
    cta_title: "Prêt à Commencer à Gagner ?",
    cta_subtitle: "Rejoignez des milliers d'acheteurs intelligents qui gagnent du cashback sur chaque achat",
    cta_button: "Commencer Maintenant",
    
    // ============== FOOTER ==============
    footer_description: "La première plateforme de cashback du Ghana connectant les consommateurs intelligents aux marchands partenaires.",
    footer_quick_links: "Liens Rapides",
    footer_support: "Support",
    footer_legal: "Mentions Légales",
    footer_contact: "Contactez-nous",
    footer_privacy: "Politique de Confidentialité",
    footer_terms: "Conditions d'Utilisation",
    footer_merchant_terms: "Conditions Marchands",
    footer_referral_terms: "Conditions du Parrainage",
    footer_cashback_rules: "Règles du Cashback",
    footer_abuse_policy: "Politique d'Abus",
    footer_faq: "FAQ",
    footer_contact: "Contacter le Support",
    footer_copyright: "© 2026 SDM Rewards. Tous droits réservés.",
    footer_address: "Accra, Ghana",
    
    // ============== COMMON ==============
    learn_more: "En Savoir Plus",
    sign_up: "S'inscrire",
    login: "Connexion",
    email: "Email",
    phone: "Numéro de Téléphone",
    password: "Mot de Passe",
    confirm_password: "Confirmer le Mot de Passe",
    full_name: "Nom Complet",
    business_name: "Nom de l'Entreprise",
    submit: "Soumettre",
    cancel: "Annuler",
    save: "Enregistrer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    
    // ============== DASHBOARD COMMON ==============
    dashboard: "Tableau de Bord",
    transactions: "Transactions",
    settings: "Paramètres",
    logout: "Déconnexion",
    balance: "Solde",
    cashback_balance: "Solde Cashback",
    total_earned: "Total Gagné",
    recent_activity: "Activité Récente",
    view_all: "Voir Tout",
    no_transactions: "Aucune transaction pour le moment",
    
    // ============== SEO ==============
    seo_title: "SDM Rewards - Plateforme Cashback Ghana | Gagnez des Récompenses sur Chaque Achat",
    seo_description: "Rejoignez SDM Rewards, la première plateforme de cashback du Ghana. Gagnez du cashback instantané chez les marchands partenaires. Obtenez votre carte aujourd'hui !",
    seo_keywords: "cashback Ghana, récompenses fidélité Afrique, cashback shopping, programme récompenses Ghana, SDM Rewards"
  }
};

// Language utility functions
export const getLanguageFromStorage = () => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('sdm_language');
    // Default to English for Ghana market
    if (!saved) {
      localStorage.setItem('sdm_language', 'en');
      return 'en';
    }
    return saved;
  }
  return 'en';
};

export const setLanguageInStorage = (lang) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('sdm_language', lang);
  }
};

export const t = (key, lang = 'en') => {
  return translations[lang]?.[key] || translations['en']?.[key] || key;
};

export default translations;
